module.exports = __webpack_public_path__ + "img/84.54ee667d.jpg";